module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_c('img', {
    attrs: {
      "src": "http://home.gamebrain.io/static/images/logo.png"
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "tools"
  }, [_vm._v("\n\t\t\t\t\t广告投放平台\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ads_nav"
  }, [_c('a', {
    class: _vm.active == 1 ? 'ads_nav_active' : '',
    on: {
      "click": function($event) {
        return _vm.open(1)
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('a', [_vm._v("市场洞察")]), _vm._v(" "), _c('a', [_vm._v("热门榜单")])])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "header_other"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "content": "站内通知",
      "placement": "bottom"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.$router.push('/message')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })])])], 1), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _c('img', {
    attrs: {
      "src": this.sysUserAvatar
    }
  }), _vm._v(" " + _vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.myset.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o"
  }), _vm._v(" 个人设置")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" 退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5791d382"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomeOut.vue
// module id = 1101
// module chunks = 36